(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFeatureCardsSwiper(root) {
      var wrap = root ? root.querySelector('.t4s-feature-cards__swiper-wrap') : null;
      var el = wrap ? wrap.querySelector('[data-fc-swiper]') : null;
      if (!el || !el.dataset.fcSwiperConfig) return;

      var run = function () {
        if (typeof Swiper === 'undefined') {
          setTimeout(run, 50);
          return;
        }

        if (el.swiper) {
          el.swiper.destroy(true, true);
        }

        var config = JSON.parse(el.dataset.fcSwiperConfig);
        var colMb = parseFloat(config.colMb) || 1;
        var colTb = parseInt(config.colTb, 10) || 2;
        var colDk = parseInt(config.colDk, 10) || 5;
        var spaceMb = parseInt(config.spaceMb, 10) || 10;
        var spaceDk = parseInt(config.spaceDk, 10) || 20;
        var slideCount = el.querySelectorAll('.swiper-slide').length;
        var paginationEl = el.querySelector('.t4s-feature-cards__pagination');
        var prevEl = wrap.querySelector('.t4s-feature-cards__nav--prev');
        var nextEl = wrap.querySelector('.t4s-feature-cards__nav--next');

        var swiperConfig = {
          slidesPerView: colMb,
          spaceBetween: spaceMb,
          watchOverflow: true,
          loop: config.loop && slideCount > colMb,
          grabCursor: true,
          breakpoints: {
            768: {
              slidesPerView: colTb,
              spaceBetween: spaceDk,
              allowTouchMove: false,
              grabCursor: false,
              loop: false
            },
            1024: {
              slidesPerView: colDk,
              spaceBetween: spaceDk,
              allowTouchMove: false,
              grabCursor: false,
              loop: false
            }
          }
        };

        if (config.pagination && paginationEl) {
          swiperConfig.pagination = {
            el: paginationEl,
            clickable: true
          };
        }

        if (config.navigation && prevEl && nextEl) {
          swiperConfig.navigation = {
            prevEl: prevEl,
            nextEl: nextEl
          };
        }

        if (config.autoplay > 0) {
          swiperConfig.autoplay = {
            delay: config.autoplay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          };
          swiperConfig.breakpoints[768].autoplay = false;
          swiperConfig.breakpoints[1024].autoplay = false;
        }

        new Swiper(el, swiperConfig);
      };

      run();
    }

    function initAll() {
      document.querySelectorAll('.t4s-feature-cards').forEach(initFeatureCardsSwiper);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.classList.contains('t4s-feature-cards') || event.target.querySelector('.t4s-feature-cards')) {
        initFeatureCardsSwiper(event.target.classList.contains('t4s-feature-cards') ? event.target : event.target.querySelector('.t4s-feature-cards'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keppi-bench-compare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('keppi-auto-compare')) {
 customElements.define('keppi-auto-compare', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const options = {signal:this.controller.signal};
   this.track = this.querySelector('.kpc-track');
   this.cards = Array.from(this.querySelectorAll('[data-card]'));
   this.controls = this.querySelector('.kpc-controls');
   this.empty = this.querySelector('.kpc-empty');
   this.live = this.querySelector('[data-live]');
   this.prev = this.querySelector('[data-prev]');
   this.next = this.querySelector('[data-next]');
   this.dots = this.querySelector('.kpc-dots');
   this.play = this.querySelector('[data-play-button]');
   this.paused = false;
   this.focused = false;
   this.hovered = false;
   this.editorPaused = false;
   this.motion = matchMedia('(prefers-reduced-motion:reduce)');
   this.prev.addEventListener('click', () => this.move(-1,true), options);
   this.next.addEventListener('click', () => this.move(1,true), options);
   this.play?.addEventListener('click', () => {
    this.paused = !this.paused;
    this.play.textContent = this.paused ? this.dataset.play : this.dataset.pause;
    this.announce(this.play.textContent);
    this.schedule();
   }, options);
   this.dots.addEventListener('click', event => {
    const dot = event.target.closest('[data-position]');
    if (dot) {this.pauseManual();this.animateTo(Number(dot.dataset.position));}
   }, options);
   this.track.addEventListener('scroll', () => {
    this.sync();
    clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(() => this.schedule(),160);
   }, {...options,passive:true});
   this.track.addEventListener('pointerdown', () => {this.pauseManual();this.cancelAnimation();}, options);
   this.track.addEventListener('keydown', event => {
    if (event.target !== this.track || !this.overflow) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();this.move(event.key === 'ArrowRight' ? 1 : -1,true);}
   }, options);
   this.addEventListener('pointerenter', event => {if(event.pointerType === 'mouse'){this.hovered = true;this.schedule();}}, options);
   this.addEventListener('pointerleave', () => {this.hovered = false;this.schedule();}, options);
   this.addEventListener('focusin', () => {this.focused = true;this.schedule();}, options);
   this.addEventListener('focusout', event => {if(!this.contains(event.relatedTarget)){this.focused=false;this.schedule();}}, options);
   this.motion.addEventListener('change', () => this.schedule(), options);
   document.addEventListener('visibilitychange', () => this.schedule(), options);
   document.addEventListener('shopify:block:select', event => {
    if (!this.contains(event.target)) return;
    this.editorPaused = true;
    const card = event.target.closest('[data-card]');
    if (card) {
     card.scrollIntoView({block:'nearest',inline:'nearest',behavior:'auto'});
    }
    this.schedule();
   }, options);
   document.addEventListener('shopify:block:deselect', event => {if(this.contains(event.target)){this.editorPaused=false;this.schedule();}}, options);
   this.observer = new ResizeObserver(() => {
    cancelAnimationFrame(this.resizeFrame);
    this.resizeFrame = requestAnimationFrame(() => this.rebuild());
   });
   this.observer.observe(this.track);
   this.track.scrollLeft = 0;
   this.rebuild();
  }
  rebuild() {
   if (!this.track) return;
   this.visible = this.cards;
   const autoCarousel =
    this.cards.length > 3 ||
    (matchMedia('(max-width:749px)').matches && this.cards.length > 1);

   this.dataset.carousel = String(autoCarousel);
   this.track.classList.toggle('kpc-track--carousel',autoCarousel);
   this.track.dataset.visible = String(this.visible.length);
   this.empty.hidden = this.visible.length > 0;
   this.track.hidden = this.visible.length === 0;
   const mobile = matchMedia('(max-width:749px)').matches;
   const tablet = matchMedia('(min-width:750px) and (max-width:989px)').matches;
   const style = getComputedStyle(this);
   this.view = mobile ? Number(style.getPropertyValue('--kpc-mobile')) : tablet ? 2 : 3;
   const cardWidth = this.visible[0]?.getBoundingClientRect().width || 0;
   const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
   this.step = (cardWidth + gap) * Math.max(1,Math.floor(this.view));
   this.max = Math.max(0,this.track.scrollWidth - this.track.clientWidth);
   this.overflow = this.dataset.carousel === 'true' && this.visible.length > 1 && this.visible.length > this.view && this.max > 2;
   this.track.tabIndex = this.overflow ? 0 : -1;
   this.controls.hidden = !this.overflow;
   this.prev.hidden = this.dataset.arrows !== 'true';
   this.next.hidden = this.dataset.arrows !== 'true';
   this.dots.hidden = this.dataset.dots !== 'true';
   this.positions = [0];
   if (this.overflow && this.step > 0) {
    for (let position=this.step;position<this.max-2;position+=this.step) this.positions.push(position);
    this.positions.push(this.max);
   }
   this.dots.replaceChildren();
   if (this.dataset.dots === 'true' && this.overflow) this.positions.forEach((position,index) => {
    const dot = document.createElement('button');
    dot.type='button';dot.className='kpc-dot';dot.dataset.position=String(position);
    dot.setAttribute('aria-label',this.dataset.dotLabel + ' ' + (index+1));
    dot.setAttribute('aria-controls',this.track.id);
    dot.append(document.createElement('span'));
    this.dots.append(dot);
   });
   this.sync();
   this.schedule();
  }
  sync() {
   const position = this.track.scrollLeft;
   const loop = this.dataset.loop === 'true';
   this.prev.disabled = !loop && position <= 2;
   this.next.disabled = !loop && position >= this.max-2;
   let nearest=0;
   (this.positions || []).forEach((value,index) => {if(Math.abs(value-position)<Math.abs(this.positions[nearest]-position))nearest=index;});
   Array.from(this.dots.children).forEach((dot,index) => {if(index===nearest)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
  }
  move(direction,manual) {
   if (!this.overflow) return;
   if (manual) this.pauseManual();
   let target=this.track.scrollLeft+direction*this.step;
   if (this.dataset.loop === 'true') {
    if(direction>0 && this.track.scrollLeft>=this.max-2)target=0;
    if(direction<0 && this.track.scrollLeft<=2)target=this.max;
   }
   this.animateTo(Math.max(0,Math.min(this.max,target)));
  }
  cancelAnimation() {
   cancelAnimationFrame(this.animation);
   if(this.track)this.track.style.scrollSnapType='';
  }
  animateTo(target) {
   this.cancelAnimation();clearTimeout(this.timer);
   const start=this.track.scrollLeft;
   const duration=this.motion.matches ? 0 : Number(this.dataset.speed);
   if(!duration){this.track.scrollLeft=target;this.sync();this.schedule();return;}
   this.track.style.scrollSnapType='none';
   const started=performance.now();
   const tick=now=>{
    const progress=Math.min(1,(now-started)/duration);
    const eased=1-Math.pow(1-progress,3);
    this.track.scrollLeft=start+(target-start)*eased;
    if(progress<1)this.animation=requestAnimationFrame(tick);
    else{this.track.style.scrollSnapType='';this.sync();this.schedule();}
   };
   this.animation=requestAnimationFrame(tick);
  }
  pauseManual() {
   this.paused=true;clearTimeout(this.timer);
   if(this.play)this.play.textContent=this.dataset.play;
  }
  schedule() {
   clearTimeout(this.timer);
   const last=this.dataset.loop!=='true' && this.track.scrollLeft>=this.max-2;
   const blocked=!this.overflow || this.dataset.autoplay!=='true' || this.paused || this.focused || this.editorPaused || document.hidden || this.motion.matches || (this.dataset.hover==='true' && this.hovered) || last;
   if(!blocked)this.timer=setTimeout(()=>this.move(1,false),Number(this.dataset.interval));
  }
  announce(text) {
   cancelAnimationFrame(this.announceFrame);this.live.textContent='';
   this.announceFrame=requestAnimationFrame(()=>{this.live.textContent=text;});
  }
  disconnectedCallback() {
   this.cancelAnimation();clearTimeout(this.timer);clearTimeout(this.scrollTimer);
   cancelAnimationFrame(this.resizeFrame);cancelAnimationFrame(this.announceFrame);
   this.observer?.disconnect();this.controller?.abort();this.controller=null;
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keppi-bench-feature"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('keppi-bench-feature')) {
  customElements.define('keppi-bench-feature', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const opts = {signal:this.controller.signal};
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.controls = this.querySelector('.kbf-controls');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.toggle = this.querySelector('[data-toggle]');
      this.announcer = this.querySelector('[data-announcer]');
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.editorPaused = false;
      this.mobileQuery = matchMedia('(max-width:749px)');
      this.motionQuery = matchMedia('(prefers-reduced-motion:reduce)');
      this.refresh = () => {
        this.active = this.dataset.enabled === 'true' && this.slides.length > 1 && (this.dataset.mobile !== 'true' || this.mobileQuery.matches);
        this.controls.hidden = !this.active;
        this.show(this.active ? this.index : 0, false, false);
      };
      this.prev?.addEventListener('click', () => this.manual(this.index - 1), opts);
      this.next?.addEventListener('click', () => this.manual(this.index + 1), opts);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.manual(index), opts));
      this.toggle?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
        this.announce(this.toggle.textContent);
        this.schedule();
      }, opts);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
      }, opts);
      this.addEventListener('pointerleave', () => {this.hovered = false; this.schedule();}, opts);
      this.addEventListener('focusin', () => {this.focused = true; this.schedule();}, opts);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) {this.focused = false; this.schedule();}
      }, opts);
      this.addEventListener('touchstart', event => {
        this.touch = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;
        clearTimeout(this.timer);
      }, {...opts,passive:true});
      this.addEventListener('touchend', event => {
        if (this.active && this.touch && event.changedTouches.length) {
          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) this.manual(this.index + (dx < 0 ? 1 : -1));
        }
        this.touch = null;
        this.schedule();
      }, {...opts,passive:true});
      this.addEventListener('touchcancel', () => {this.touch = null; this.schedule();}, opts);
      document.addEventListener('visibilitychange', () => this.schedule(), opts);
      this.mobileQuery.addEventListener('change', this.refresh, opts);
      this.motionQuery.addEventListener('change', () => this.schedule(), opts);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const article = event.target.closest('[data-slide]');
        const feature = event.target.closest('[data-feature-key]');
        const key = article?.dataset.slideKey || feature?.dataset.featureKey;
        const target = this.slides.findIndex(slide => slide.dataset.slideKey === key);
        this.editorPaused = true;
        if (target >= 0) this.show(target, false, true);
        else this.schedule();
      }, opts);
      document.addEventListener('shopify:block:deselect', event => {
        if (this.contains(event.target)) {this.editorPaused = false;this.schedule();}
      }, opts);
      this.refresh();
    }
    announce(text) {
      cancelAnimationFrame(this.raf);
      this.announcer.textContent = '';
      this.raf = requestAnimationFrame(() => {this.announcer.textContent = text;});
    }
    manual(index) {
      if (!this.active) return;
      // Manual navigation stops autoplay until explicitly restarted.
      if (this.dataset.autoplay === 'true') {
        this.paused = true;
        if (this.toggle) this.toggle.textContent = this.dataset.play;
      }
      this.show(index, true, false);
    }
    show(index, announce, editor) {
      if (!this.slides.length) return;
      if (this.dataset.loop === 'true') index = (index + this.slides.length) % this.slides.length;
      else index = Math.max(0, Math.min(index, this.slides.length - 1));
      const focused = document.activeElement;
      const outgoing = this.slides[this.index];
      // Never hide the user's focused content during automatic playback.
      if (!editor && !announce && index !== this.index && outgoing?.contains(focused)) {this.schedule();return;}
      this.index = index;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== index;
        slide.inert = i !== index;
        if (i !== index) slide.setAttribute('aria-hidden', 'true');
        else slide.removeAttribute('aria-hidden');
      });
      this.dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      const loop = this.dataset.loop === 'true';
      if (this.prev) this.prev.disabled = !loop && index === 0;
      if (this.next) this.next.disabled = !loop && index === this.slides.length - 1;
      if (announce) this.announce(this.dataset.status + ' ' + (index + 1) + ' / ' + this.slides.length);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const last = this.index === this.slides.length - 1 && this.dataset.loop !== 'true';
      const blocked = !this.active || this.dataset.autoplay !== 'true' || this.paused || this.focused || this.editorPaused || document.hidden || this.motionQuery.matches || (this.dataset.hover === 'true' && this.hovered) || last;
      if (!blocked) this.timer = setTimeout(() => this.show(this.index + 1, false, false), Number(this.dataset.interval));
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      cancelAnimationFrame(this.raf);
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keppi-foundation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('keppi-foundation')) {
    customElements.define('keppi-foundation', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.track = this.querySelector('.kf-track');
        this.controls = this.querySelector('.kf-controls');
        this.buttons = Array.from(this.querySelectorAll('.kf-arrow'));
        if (!this.track) return;
        this.update = () => {
          const scrollable = getComputedStyle(this.track).overflowX === 'auto';
          const overflow = this.track.scrollWidth - this.track.clientWidth;
          const enabled = Number(this.dataset.count) > 1 && scrollable && overflow > 2;
          this.controls.hidden = !enabled;
          this.track.tabIndex = enabled ? 0 : -1;
          this.buttons[0].disabled = !enabled || this.track.scrollLeft <= 2;
          this.buttons[1].disabled = !enabled || this.track.scrollLeft >= overflow - 2;
        };
        this.move = (direction) => {
          const card = this.track.querySelector('.kf-card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const amount = card.getBoundingClientRect().width + gap;
          this.track.scrollBy({left: direction * amount, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        this.buttons.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.direction)), options));
        this.track.addEventListener('scroll', this.update, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || this.controls.hidden) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.addEventListener('focusin', event => {
          const card = event.target.closest('.kf-card');
          if (card && !this.controls.hidden) card.scrollIntoView({block:'nearest', inline:'nearest', behavior:'auto'});
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.kf-card');
          if (card && this.contains(card) && !this.controls.hidden) card.scrollIntoView({block:'nearest', inline:'nearest', behavior:'auto'});
        }, options);
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-videos-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRvGridSwiper(root) {
      var wrap = root ? root.querySelector('.t4s-rv-grid__swiper-wrap') : null;
      var el = wrap ? wrap.querySelector('[data-rvg-swiper]') : null;
      if (!el || !el.dataset.rvgSwiperConfig) return;

      var header = root ? root.querySelector('.t4s-rv-grid__header') : null;
      var prevEl = header ? header.querySelector('.t4s-rv-grid__nav--prev') : null;
      var nextEl = header ? header.querySelector('.t4s-rv-grid__nav--next') : null;

      var run = function () {
        if (typeof Swiper === 'undefined') {
          setTimeout(run, 50);
          return;
        }

        if (el.swiper) {
          el.swiper.destroy(true, true);
        }

        var config = JSON.parse(el.dataset.rvgSwiperConfig);
        var colMb = parseFloat(config.colMb) || 1.2;
        var colTb = parseFloat(config.colTb) || 2;
        var colDk = parseFloat(config.colDk) || 3;
        var spaceMb = parseInt(config.spaceMb, 10) || 12;
        var spaceDk = parseInt(config.spaceDk, 10) || 24;
        var slideCount = el.querySelectorAll('.swiper-slide').length;
        var paginationEl = el.querySelector('.t4s-rv-grid__pagination');

        var swiperConfig = {
          slidesPerView: colMb,
          spaceBetween: spaceMb,
          watchOverflow: true,
          loop: config.loop && slideCount > Math.ceil(colMb),
          grabCursor: true,
          breakpoints: {
            768: {
              slidesPerView: colTb,
              spaceBetween: spaceDk,
              loop: config.loop && slideCount > Math.ceil(colTb)
            },
            1024: {
              slidesPerView: colDk,
              spaceBetween: spaceDk,
              loop: config.loop && slideCount > Math.ceil(colDk)
            }
          }
        };

        if (config.pagination && paginationEl) {
          swiperConfig.pagination = {
            el: paginationEl,
            clickable: true
          };
        }

        if (config.navigation && prevEl && nextEl) {
          swiperConfig.navigation = {
            prevEl: prevEl,
            nextEl: nextEl
          };
        }

        if (config.autoplay > 0) {
          swiperConfig.autoplay = {
            delay: config.autoplay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          };
        }

        new Swiper(el, swiperConfig);
      };

      run();
    }

    function initAll() {
      document.querySelectorAll('.t4s-related-videos-grid').forEach(initRvGridSwiper);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.classList.contains('t4s-related-videos-grid') || event.target.querySelector('.t4s-related-videos-grid')) {
        initRvGridSwiper(event.target.classList.contains('t4s-related-videos-grid') ? event.target : event.target.querySelector('.t4s-related-videos-grid'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRelatedVideosSwiper(root) {
      var wrap = root ? root.querySelector('.t4s-related-videos__swiper-wrap') : null;
      var el = wrap ? wrap.querySelector('[data-rv-swiper]') : null;
      if (!el || !el.dataset.rvSwiperConfig) return;

      var run = function () {
        if (typeof Swiper === 'undefined') {
          setTimeout(run, 50);
          return;
        }

        if (el.swiper) {
          el.swiper.destroy(true, true);
        }

        var config = JSON.parse(el.dataset.rvSwiperConfig);
        var colMb = parseFloat(config.colMb) || 1.2;
        var colTb = parseFloat(config.colTb) || 2.5;
        var colDk = parseFloat(config.colDk) || 4.5;
        var spaceMb = parseInt(config.spaceMb, 10) || 12;
        var spaceDk = parseInt(config.spaceDk, 10) || 20;
        var slideCount = el.querySelectorAll('.swiper-slide').length;
        var paginationEl = el.querySelector('.t4s-related-videos__pagination');
        var prevEl = wrap.querySelector('.t4s-related-videos__nav--prev');
        var nextEl = wrap.querySelector('.t4s-related-videos__nav--next');

        var swiperConfig = {
          slidesPerView: colMb,
          spaceBetween: spaceMb,
          watchOverflow: true,
          loop: config.loop && slideCount > Math.ceil(colMb),
          grabCursor: true,
          breakpoints: {
            768: {
              slidesPerView: colTb,
              spaceBetween: spaceDk,
              loop: config.loop && slideCount > Math.ceil(colTb)
            },
            1024: {
              slidesPerView: colDk,
              spaceBetween: spaceDk,
              loop: config.loop && slideCount > Math.ceil(colDk)
            }
          }
        };

        if (config.pagination && paginationEl) {
          swiperConfig.pagination = {
            el: paginationEl,
            clickable: true
          };
        }

        if (config.navigation && prevEl && nextEl) {
          swiperConfig.navigation = {
            prevEl: prevEl,
            nextEl: nextEl
          };
        }

        if (config.autoplay > 0) {
          swiperConfig.autoplay = {
            delay: config.autoplay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          };
        }

        new Swiper(el, swiperConfig);
      };

      run();
    }

    function initAll() {
      document.querySelectorAll('.t4s-related-videos').forEach(initRelatedVideosSwiper);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.classList.contains('t4s-related-videos') || event.target.querySelector('.t4s-related-videos')) {
        initRelatedVideosSwiper(event.target.classList.contains('t4s-related-videos') ? event.target : event.target.querySelector('.t4s-related-videos'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
